import React from 'react';
import './CouponFilterTabs.css';

const CouponFilterTabs = ({ activeFilter, onFilterChange }) => {
  const tabs = ['Active', 'Scheduled', 'Expired', 'All'];

  return (
    <div className="coupon-filter-tabs">
      {tabs.map(tab => (
        <button
          key={tab}
          className={`filter-tab ${activeFilter === tab ? 'active' : ''}`}
          onClick={() => onFilterChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default CouponFilterTabs;

